import axios from 'ts-axios-new';
import type {AchievementApiEnvelope, AchievementResourceUploadResult} from '../types/achievement';

export const ACHIEVEMENT_ENDPOINTS = {
    catalog: '/cms/v1/achievement/catalog',
    resources: '/cms/v1/achievement/resources',
    validate: '/cms/v1/achievement/resources/validate',
    publish: '/cms/v1/achievement/resources/publish',
} as const;

export async function fetchAchievementCatalog(): Promise<unknown> {
    const response = await axios.get<AchievementApiEnvelope>(ACHIEVEMENT_ENDPOINTS.catalog);
    return response.data?.data;
}

export async function saveAchievementCatalog(catalog: unknown, revision: string): Promise<unknown> {
    const response = await axios.put<AchievementApiEnvelope>(ACHIEVEMENT_ENDPOINTS.catalog, {catalog, revision});
    return response.data?.data;
}

export async function fetchAchievementResources(catalogVersion = 1): Promise<unknown> {
    const response = await axios.get<AchievementApiEnvelope>(ACHIEVEMENT_ENDPOINTS.resources, {
        params: {catalog_version: catalogVersion},
    });
    return response.data?.data;
}

export async function validateAchievementResources(resources: unknown): Promise<unknown> {
    const response = await axios.post<AchievementApiEnvelope>(ACHIEVEMENT_ENDPOINTS.validate, {resources});
    return response.data?.data;
}

export async function publishAchievementResources(resources: unknown, revision: string): Promise<unknown> {
    const response = await axios.post<AchievementApiEnvelope>(ACHIEVEMENT_ENDPOINTS.publish, {resources, revision});
    return response.data?.data;
}

export async function uploadAchievementImageResource(file: File): Promise<AchievementResourceUploadResult> {
    const form = new FormData();
    form.append('file', file, file.name);
    const response = await axios.post<AchievementApiEnvelope<AchievementResourceUploadResult>>(
        '/cms/v1/achievement-resource', form,
    );
    const detail = String(response.data?.data?.detail || '').trim();
    const thumbnail = String(response.data?.data?.thumbnail || '').trim();
    if (!detail || !thumbnail) throw new Error(`${file.name} 上传成功但未返回详情图和缩略图`);
    return {detail, thumbnail};
}
